export const addonAlignments = {
    left: 'left',
    right: 'right',
};
export const borderTypes = {
    bottom: 'bottom',
    full: 'full',
    none: 'none',
};
export const textInputSizes = {
    medium: 'medium',
    small: 'small',
};
export const textInputTypes = {
    date: 'date',
    email: 'email',
    password: 'password',
    tel: 'tel',
    text: 'text',
};
export const textInputHeights = {
    [textInputSizes.small]: 40,
    [textInputSizes.medium]: 48,
};
